import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './accordion.magic.css.js';
import script from './accordion.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",class:[_vm.elevationClass, {'accordion--elevation-gap': _vm.elevation, 'accordion--top-navigation': _vm.topNavVariant}],attrs:{"part":_vm.$p('accordion', [_vm.elevationClass, { 'accordion--elevation-gap': _vm.elevation, 'accordion--top-navigation': _vm.topNavVariant }])}},[(!_vm.hideAccordionToggle)?_c('div',{staticClass:"toggle",class:{ 
            'toggle--wide': _vm.wide,
            'toggle--elevation-expanded': _vm.elevation && _vm.visible,
            'toggle--elevation-no-expanded': _vm.elevation && !_vm.visible,
            'toggle--top-navigation': _vm.topNavVariant, 
            'toggle--top-navigation-open': _vm.topNavVariant && _vm.visible
        },attrs:{"data-v-test-id":"accordion-toggle","part":_vm.$p('toggle', { 
            'toggle--wide': _vm.wide, 
            'toggle--elevation-expanded': _vm.elevation && _vm.visible, 
            'toggle--elevation-no-expanded': _vm.elevation && !_vm.visible, 
            'toggle--top-navigation': _vm.topNavVariant,
            'toggle--top-navigation-open': _vm.topNavVariant && _vm.visible 
        })},on:{"click":_vm.toggle}},[_vm._t("toggle",null,{"visible":_vm.visible}),_vm._v(" "),_c('div',{staticClass:"icons",class:{'icons--top-navigation': _vm.topNavVariant},attrs:{"part":_vm.$p('icons', { 'icons--top-navigation': _vm.topNavVariant })}},[_c('magic-ui-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"icon",attrs:{"name":"up-arrow","part":"icon","data-v-test-id":"icon-up-arrow"}}),_vm._v(" "),_c('magic-ui-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.visible),expression:"!visible"}],staticClass:"icon",attrs:{"name":"down-arrow","part":"icon","data-v-test-id":"icon-down-arrow"}})],1)],2):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[(_vm.visible)?_c('div',{staticClass:"content",class:{
                'content--no-animation': _vm.noAnimation,
                'content--no-overflow': _vm.noOverflow,
                'content--elevation': _vm.elevation,
            },attrs:{"data-v-test-id":"accordion-content","part":_vm.$p('content', {
                'content--no-animation': _vm.noAnimation,
                'content--no-overflow': _vm.noOverflow,
                'content--elevation': _vm.elevation,
            })}},[_vm._t("content")],2):_vm._e()])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-478ccf62_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-478ccf62";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
